import { isTimestampInRange, parseOppDate } from './dashboardDateRange';

export function opportunityMatchesLocationFilters(opp, filters) {
  if (!opp.Location_Name__r) {
    return filters.country === 'All' && filters.state === 'All' && filters.propertyCategory === 'All';
  }
  const location = opp.Location_Name__r;
  const country = location.BillingCountry || '';
  const state = location.BillingState || '';
  const propertyCategory = location.Property_Category__c || '';

  if (filters.country !== 'All') {
    if (!country || country.trim() === '' || country !== filters.country) return false;
  }
  if (filters.state !== 'All') {
    if (!state || state.trim() === '' || state !== filters.state) return false;
  }
  if (filters.propertyCategory !== 'All') {
    if (!propertyCategory || propertyCategory.trim() === '' || propertyCategory !== filters.propertyCategory) {
      return false;
    }
  }
  return true;
}

export function filterClientsByLocation(clients, filters) {
  return clients.map((client) => ({
    ...client,
    opportunities: client.opportunities?.filter((opp) => opportunityMatchesLocationFilters(opp, filters)) || [],
  }));
}

export function isCreatedInRange(opp, startMs, endMs) {
  const ts = parseOppDate(opp.CreatedDate);
  return ts != null && isTimestampInRange(ts, startMs, endMs);
}

export function isClosedInRange(opp, startMs, endMs) {
  const ts = parseOppDate(opp.CloseDate);
  return ts != null && isTimestampInRange(ts, startMs, endMs);
}
